import React from "react";

function Sectionimage() {
    return (
        <>
            <section className="section bg-SectionImage" id="clients">
                <div className="bg-overlay"></div>
                <div className="container my-3 py-2">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="slick-slider client-slider slick-initialized">
                                <div
                                    className="slick-slide slick-cloned"
                                    aria-hidden="true"
                                >
                                    <div>
                                        <div className="content-box">
                                            <div className="testi-content">
                                                <div className="testi-box mt-4">
                                                    <h5 className="text-white mb-3 fw-light">
                                                        "najwa shihab"
                                                    </h5>
                                                    <p className="text-white fw-light mb-0 f-15">
                                                        membaca ialah upaya
                                                        untuk merekuk makna
                                                        ikhtiar untuk memahami
                                                        alam semesta. Itulah
                                                        mengapa buku disebut
                                                        jendela dunia, yang
                                                        merangsang pikiran agar
                                                        terus terbuka
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Sectionimage;
